import {
  ONBOARDING_STEPS,
  STEP_LABELS,
  type OnboardingStepKey,
} from '../../onboarding/onboardingSteps';

type Props = {
  currentStep: string;
  completedSteps: string[];
  onVisitStep?: (step: OnboardingStepKey) => void;
};

const OnboardingTimeline = ({
  currentStep,
  completedSteps,
  onVisitStep,
}: Props) => {
  const currentIdx = ONBOARDING_STEPS.indexOf(currentStep as OnboardingStepKey);

  const rowBase =
    'flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm leading-snug';
  const bulletBase =
    'flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border-2 text-xs font-bold';

  return (
    <nav aria-label="Onboarding progress">
      <ol className="m-0 flex list-none flex-col gap-0.5 p-0">
        {ONBOARDING_STEPS.map((step, index) => {
          const done = completedSteps.includes(step);
          const active = currentStep === step;
          const canVisit =
            !!onVisitStep &&
            !active &&
            (done || (currentIdx >= 0 && index < currentIdx));

          const rowState = done
            ? 'text-secondary/78'
            : active
              ? 'bg-secondary/10 font-semibold text-foreground'
              : 'text-muted-foreground';

          const bulletState = done
            ? 'border-secondary/55 bg-secondary/15 text-secondary'
            : active
              ? 'border-secondary/55 bg-secondary/38 text-[color:var(--nq-white)]'
              : 'border-[color:var(--nq-line-soft)]';

          const content = (
            <>
              <span className={`${bulletBase} ${bulletState}`} aria-hidden>
                {done ? '✓' : index + 1}
              </span>
              <span className="min-w-0 flex-1">
                {STEP_LABELS[step as OnboardingStepKey]}
              </span>
            </>
          );

          return (
            <li key={step} className={canVisit ? '' : `${rowBase} ${rowState}`}>
              {canVisit ? (
                <button
                  type="button"
                  className={`${rowBase} ${rowState} w-full cursor-pointer border-0 bg-transparent text-left font-[inherit] transition-colors ${
                    done
                      ? 'hover:bg-secondary/8 hover:text-secondary'
                      : ''
                  }`}
                  onClick={() => onVisitStep(step as OnboardingStepKey)}
                >
                  {content}
                </button>
              ) : (
                content
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default OnboardingTimeline;
